module.exports = __webpack_public_path__ + "img/list-tree.3bcd7e.svg";